import type { AppProblemModel } from '~/services/api/AppProblemModel'

/**
 * True for any STORE_TEMPORARILY_CLOSED problem, scheduled or indefinite; the single check
 * every availability-check consumer uses so the predicate never drifts between call sites.
 */
export function isStoreClosureProblem(problem: AppProblemModel): boolean {
  return problem.reason === 'STORE_TEMPORARILY_CLOSED'
}
